import { computed, observable, makeObservable } from 'mobx';
import { v4 as uuid } from 'uuid';

import { ContactPersonData, Optional } from 'chaika-frontend-types/frontend-cms';

import { InitParams, Form, ValidationType } from '@store/abstract/Form';

export class ContactPersonForm extends Form {
    public technicalId: string;

    @observable
    public firstName: string;

    @observable
    public lastName: string;

    @observable
    public patronymic: Optional<string>;

    @observable
    public phone!: string;

    constructor({ firstName, lastName, patronymic, phone }: ContactPersonData) {
        super();
        makeObservable(this);

        this.technicalId = uuid();
        this.firstName = firstName;
        this.lastName = lastName;
        this.patronymic = patronymic;
        this.setFieldValue('phone', phone);

        this.init();
    }

    @computed
    public get fullName(): string {
        return `${this.lastName} ${this.firstName} ${this.patronymic ?? ''}`;
    }

    @computed
    public get shortFullName(): string {
        return `${this.lastName} ${this.firstName}`;
    }

    public serialize(): ContactPersonData {
        return {
            firstName: this.firstName,
            lastName: this.lastName,
            patronymic: this.patronymic,
            phone: this.onlyNumbers(this.phone),
        };
    }

    protected getInitParams(): InitParams[] {
        return [
            {
                name: 'firstName',
                isRequired: true,
                validation: [ValidationType.notEmpty, ValidationType.Name],
            },
            {
                name: 'lastName',
                isRequired: true,
                validation: [ValidationType.notEmpty, ValidationType.Name],
            },
            {
                name: 'patronymic',
                validation: ValidationType.Word,
            },
            {
                name: 'phone',
                isRequired: true,
                validation: ValidationType.PhoneString,
            },
        ];
    }
}
